import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
import { computed } from "vue";
import { Image, Page, Text, View } from "@ceereals/vue-pdf";
import { formatFieldLabel, formatPdfCurrency, formatPdfDate, formatPdfTime, getEndDatetime, getStartDatetime, } from "./itinerary-pdf-formatters";
import { getItineraryPdfPricing } from "./itinerary-pdf-pricing";
import { createItineraryPdfStyles } from "./styles";
import { translatePdf } from "./pdf-i18n";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ServicePage',
    props: {
        item: {},
        index: {},
        totalServices: {},
        itineraryCode: {},
        theme: {},
        locale: {}
    },
    setup(__props) {
        const props = __props;
        function t(key, named) {
            return translatePdf(props.locale, key, named);
        }
        const styles = computed(() => createItineraryPdfStyles(props.theme).serviceStyles);
        const service = computed(() => props.item.service ?? {});
        const provider = computed(() => service.value.provider ?? {});
        const photos = computed(() => (service.value.photos ?? []).filter((photo) => Boolean(photo.image_url)));
        const serviceType = computed(() => service.value.service_type ?? null);
        const customFieldValues = computed(() => props.item.custom_field_values ?? {});
        const customFieldEntries = computed(() => Object.entries(customFieldValues.value).filter(([, value]) => {
            if (value === null || value === undefined || value === "")
                return false;
            if (Array.isArray(value) && value.length === 0)
                return false;
            return true;
        }));
        const startDatetime = computed(() => getStartDatetime(props.item));
        const endDatetime = computed(() => getEndDatetime(props.item));
        const pricing = computed(() => getItineraryPdfPricing(props.item, props.locale));
        const serviceSubtotal = computed(() => pricing.value.serviceSubtotal);
        const chargeLines = computed(() => pricing.value.charges);
        const subtotal = computed(() => pricing.value.subtotal);
        const taxAmount = computed(() => pricing.value.taxAmount);
        const total = computed(() => pricing.value.total);
        const taxRate = computed(() => pricing.value.taxRate);
        const participants = computed(() => props.item.quantity_of_participants ?? props.item.participants ?? "-");
        const durationHours = computed(() => service.value.duration ? service.value.duration / 60 : 0);
        const durationLabel = computed(() => t(durationHours.value === 1
            ? "pdf.service.duration_hour_singular"
            : "pdf.service.duration_hour_plural", { count: durationHours.value }));
        function fieldLabel(key) {
            const schema = serviceType.value?.custom_fields_schema ?? [];
            return (schema.find((field) => field.key === key)?.label || formatFieldLabel(key));
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(Page), {
                size: "A4",
                style: _normalizeStyle(styles.value.page)
            }, {
                default: _withCtx(() => [
                    _createVNode(_unref(View), {
                        style: _normalizeStyle(styles.value.header)
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_unref(View), {
                                style: _normalizeStyle(styles.value.serviceNumber)
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_unref(Text), {
                                        style: _normalizeStyle(styles.value.serviceNumberText)
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(__props.index + 1), 1)
                                        ]),
                                        _: 1
                                    }, 8, ["style"])
                                ]),
                                _: 1
                            }, 8, ["style"]),
                            _createVNode(_unref(View), {
                                style: _normalizeStyle(styles.value.headerContent)
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_unref(Text), {
                                        style: _normalizeStyle(styles.value.serviceTitle)
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(service.value.name || t("pdf.common.service_fallback")), 1)
                                        ]),
                                        _: 1
                                    }, 8, ["style"]),
                                    _createVNode(_unref(Text), {
                                        style: _normalizeStyle(styles.value.providerName)
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(provider.value.company_name || provider.value.name || t("pdf.common.provider_fallback")), 1)
                                        ]),
                                        _: 1
                                    }, 8, ["style"])
                                ]),
                                _: 1
                            }, 8, ["style"])
                        ]),
                        _: 1
                    }, 8, ["style"]),
                    (photos.value.length > 0)
                        ? (_openBlock(), _createBlock(_unref(View), {
                            key: 0,
                            style: _normalizeStyle(styles.value.photoSection)
                        }, {
                            default: _withCtx(() => [
                                (photos.value.length === 1 && photos.value[0]?.image_url)
                                    ? (_openBlock(), _createBlock(_unref(View), {
                                        key: 0,
                                        style: _normalizeStyle(styles.value.photoLargeWrapper)
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_unref(Image), {
                                                src: photos.value[0].image_url,
                                                style: _normalizeStyle(styles.value.photoLarge)
                                            }, null, 8, ["src", "style"])
                                        ]),
                                        _: 1
                                    }, 8, ["style"]))
                                    : (photos.value.length === 2)
                                        ? (_openBlock(), _createBlock(_unref(View), {
                                            key: 1,
                                            style: _normalizeStyle(styles.value.photoGrid)
                                        }, {
                                            default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(photos.value.slice(0, 2), (photo, photoIndex) => {
                                                    return (_openBlock(), _createBlock(_unref(View), {
                                                        key: photoIndex,
                                                        style: _normalizeStyle(styles.value.photoMediumWrapper)
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_unref(Image), {
                                                                src: photo.image_url,
                                                                style: _normalizeStyle(styles.value.photoMedium)
                                                            }, null, 8, ["src", "style"])
                                                        ]),
                                                        _: 2
                                                    }, 1032, ["style"]));
                                                }), 128))
                                            ]),
                                            _: 1
                                        }, 8, ["style"]))
                                        : (_openBlock(), _createBlock(_unref(View), { key: 2 }, {
                                            default: _withCtx(() => [
                                                (photos.value[0]?.image_url)
                                                    ? (_openBlock(), _createBlock(_unref(View), {
                                                        key: 0,
                                                        style: _normalizeStyle(styles.value.photoLargeWrapper)
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_unref(Image), {
                                                                src: photos.value[0].image_url,
                                                                style: _normalizeStyle(styles.value.photoLarge)
                                                            }, null, 8, ["src", "style"])
                                                        ]),
                                                        _: 1
                                                    }, 8, ["style"]))
                                                    : _createCommentVNode("", true),
                                                _createVNode(_unref(View), {
                                                    style: _normalizeStyle(styles.value.photoGrid)
                                                }, {
                                                    default: _withCtx(() => [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(photos.value.slice(1, 4), (photo, photoIndex) => {
                                                            return (_openBlock(), _createBlock(_unref(View), {
                                                                key: photoIndex,
                                                                style: _normalizeStyle(styles.value.photoSmallWrapper)
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _createVNode(_unref(Image), {
                                                                        src: photo.image_url,
                                                                        style: _normalizeStyle(styles.value.photoSmall)
                                                                    }, null, 8, ["src", "style"])
                                                                ]),
                                                                _: 2
                                                            }, 1032, ["style"]));
                                                        }), 128))
                                                    ]),
                                                    _: 1
                                                }, 8, ["style"])
                                            ]),
                                            _: 1
                                        }))
                            ]),
                            _: 1
                        }, 8, ["style"]))
                        : _createCommentVNode("", true),
                    (service.value.description)
                        ? (_openBlock(), _createBlock(_unref(View), {
                            key: 1,
                            style: _normalizeStyle(styles.value.sectionWithBorder)
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_unref(Text), {
                                    style: _normalizeStyle(styles.value.sectionTitle)
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(t("pdf.service.description")), 1)
                                    ]),
                                    _: 1
                                }, 8, ["style"]),
                                _createVNode(_unref(Text), {
                                    style: _normalizeStyle(styles.value.description)
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(service.value.description), 1)
                                    ]),
                                    _: 1
                                }, 8, ["style"])
                            ]),
                            _: 1
                        }, 8, ["style"]))
                        : _createCommentVNode("", true),
                    _createVNode(_unref(View), {
                        style: _normalizeStyle(styles.value.sectionWithBorder)
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_unref(Text), {
                                style: _normalizeStyle(styles.value.sectionTitle)
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(t("pdf.service.schedule")), 1)
                                ]),
                                _: 1
                            }, 8, ["style"]),
                            _createVNode(_unref(View), {
                                style: _normalizeStyle(styles.value.scheduleGrid)
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_unref(View), {
                                        style: _normalizeStyle(styles.value.scheduleItem)
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_unref(Text), {
                                                style: _normalizeStyle(styles.value.scheduleLabel)
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(t("pdf.service.date")), 1)
                                                ]),
                                                _: 1
                                            }, 8, ["style"]),
                                            _createVNode(_unref(Text), {
                                                style: _normalizeStyle(styles.value.scheduleValue)
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_unref(formatPdfDate)(startDatetime.value, __props.locale)), 1)
                                                ]),
                                                _: 1
                                            }, 8, ["style"])
                                        ]),
                                        _: 1
                                    }, 8, ["style"]),
                                    _createVNode(_unref(View), {
                                        style: _normalizeStyle(styles.value.scheduleItem)
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_unref(Text), {
                                                style: _normalizeStyle(styles.value.scheduleLabel)
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(t("pdf.service.start_time")), 1)
                                                ]),
                                                _: 1
                                            }, 8, ["style"]),
                                            _createVNode(_unref(Text), {
                                                style: _normalizeStyle(styles.value.scheduleValue)
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_unref(formatPdfTime)(startDatetime.value, __props.locale)), 1)
                                                ]),
                                                _: 1
                                            }, 8, ["style"])
                                        ]),
                                        _: 1
                                    }, 8, ["style"]),
                                    _createVNode(_unref(View), {
                                        style: _normalizeStyle(styles.value.scheduleItem)
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_unref(Text), {
                                                style: _normalizeStyle(styles.value.scheduleLabel)
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(t("pdf.service.end_time")), 1)
                                                ]),
                                                _: 1
                                            }, 8, ["style"]),
                                            _createVNode(_unref(Text), {
                                                style: _normalizeStyle(styles.value.scheduleValue)
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_unref(formatPdfTime)(endDatetime.value, __props.locale)), 1)
                                                ]),
                                                _: 1
                                            }, 8, ["style"])
                                        ]),
                                        _: 1
                                    }, 8, ["style"]),
                                    _createVNode(_unref(View), {
                                        style: _normalizeStyle(styles.value.scheduleItem)
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_unref(Text), {
                                                style: _normalizeStyle(styles.value.scheduleLabel)
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(t("pdf.service.participants")), 1)
                                                ]),
                                                _: 1
                                            }, 8, ["style"]),
                                            _createVNode(_unref(Text), {
                                                style: _normalizeStyle(styles.value.scheduleValue)
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(participants.value), 1)
                                                ]),
                                                _: 1
                                            }, 8, ["style"])
                                        ]),
                                        _: 1
                                    }, 8, ["style"]),
                                    (service.value.duration)
                                        ? (_openBlock(), _createBlock(_unref(View), {
                                            key: 0,
                                            style: _normalizeStyle(styles.value.scheduleItem)
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_unref(Text), {
                                                    style: _normalizeStyle(styles.value.scheduleLabel)
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(t("pdf.service.duration")), 1)
                                                    ]),
                                                    _: 1
                                                }, 8, ["style"]),
                                                _createVNode(_unref(Text), {
                                                    style: _normalizeStyle(styles.value.scheduleValue)
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(durationLabel.value), 1)
                                                    ]),
                                                    _: 1
                                                }, 8, ["style"])
                                            ]),
                                            _: 1
                                        }, 8, ["style"]))
                                        : _createCommentVNode("", true)
                                ]),
                                _: 1
                            }, 8, ["style"])
                        ]),
                        _: 1
                    }, 8, ["style"]),
                    (customFieldEntries.value.length > 0)
                        ? (_openBlock(), _createBlock(_unref(View), {
                            key: 2,
                            style: _normalizeStyle(styles.value.specialFieldsSection)
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_unref(Text), {
                                    style: _normalizeStyle(styles.value.specialFieldsTitle)
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(serviceType.value?.name || t("pdf.service.additional_info_fallback")), 1)
                                    ]),
                                    _: 1
                                }, 8, ["style"]),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customFieldEntries.value, ([key, value], fieldIndex) => {
                                    return (_openBlock(), _createBlock(_unref(View), {
                                        key: key,
                                        style: _normalizeStyle([
                                            styles.value.specialFieldRow,
                                            fieldIndex === customFieldEntries.value.length - 1
                                                ? styles.value.specialFieldRowLast
                                                : null,
                                        ])
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_unref(Text), {
                                                style: _normalizeStyle(styles.value.specialFieldLabel)
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(fieldLabel(key)), 1)
                                                ]),
                                                _: 2
                                            }, 1032, ["style"]),
                                            _createVNode(_unref(Text), {
                                                style: _normalizeStyle(styles.value.specialFieldValue)
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(value || "-"), 1)
                                                ]),
                                                _: 2
                                            }, 1032, ["style"])
                                        ]),
                                        _: 2
                                    }, 1032, ["style"]));
                                }), 128))
                            ]),
                            _: 1
                        }, 8, ["style"]))
                        : _createCommentVNode("", true),
                    (__props.item.additional_information_snapshot)
                        ? (_openBlock(), _createBlock(_unref(View), {
                            key: 3,
                            style: _normalizeStyle(styles.value.additionalInfoSection)
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_unref(Text), {
                                    style: _normalizeStyle(styles.value.sectionTitle)
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(t("pdf.service.provider_notes")), 1)
                                    ]),
                                    _: 1
                                }, 8, ["style"]),
                                _createVNode(_unref(Text), {
                                    style: _normalizeStyle(styles.value.notesText)
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(__props.item.additional_information_snapshot), 1)
                                    ]),
                                    _: 1
                                }, 8, ["style"])
                            ]),
                            _: 1
                        }, 8, ["style"]))
                        : _createCommentVNode("", true),
                    (__props.item.notes)
                        ? (_openBlock(), _createBlock(_unref(View), {
                            key: 4,
                            style: _normalizeStyle(styles.value.notesSection)
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_unref(Text), {
                                    style: _normalizeStyle(styles.value.sectionTitle)
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(t("pdf.service.booking_notes")), 1)
                                    ]),
                                    _: 1
                                }, 8, ["style"]),
                                _createVNode(_unref(Text), {
                                    style: _normalizeStyle(styles.value.notesText)
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(__props.item.notes), 1)
                                    ]),
                                    _: 1
                                }, 8, ["style"])
                            ]),
                            _: 1
                        }, 8, ["style"]))
                        : _createCommentVNode("", true),
                    _createVNode(_unref(View), {
                        style: _normalizeStyle(styles.value.pricingSection)
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_unref(Text), {
                                style: _normalizeStyle(styles.value.pricingTitle)
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(t("pdf.service.cost_summary")), 1)
                                ]),
                                _: 1
                            }, 8, ["style"]),
                            _createVNode(_unref(View), {
                                style: _normalizeStyle(styles.value.pricingRow)
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_unref(Text), {
                                        style: _normalizeStyle(styles.value.pricingLabel)
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(t("pdf.service.subtotal")), 1)
                                        ]),
                                        _: 1
                                    }, 8, ["style"]),
                                    _createVNode(_unref(Text), {
                                        style: _normalizeStyle(styles.value.pricingValue)
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_unref(formatPdfCurrency)(serviceSubtotal.value)), 1)
                                        ]),
                                        _: 1
                                    }, 8, ["style"])
                                ]),
                                _: 1
                            }, 8, ["style"]),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chargeLines.value, (charge) => {
                                return (_openBlock(), _createBlock(_unref(View), {
                                    key: charge.name,
                                    style: _normalizeStyle(styles.value.pricingRow)
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_unref(Text), {
                                            style: _normalizeStyle(styles.value.pricingLabel)
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(charge.name), 1)
                                            ]),
                                            _: 2
                                        }, 1032, ["style"]),
                                        _createVNode(_unref(Text), {
                                            style: _normalizeStyle(styles.value.pricingValue)
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_unref(formatPdfCurrency)(charge.computedAmount)), 1)
                                            ]),
                                            _: 2
                                        }, 1032, ["style"])
                                    ]),
                                    _: 2
                                }, 1032, ["style"]));
                            }), 128)),
                            _createVNode(_unref(View), {
                                style: _normalizeStyle(styles.value.pricingRow)
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_unref(Text), {
                                        style: _normalizeStyle(styles.value.pricingLabel)
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(t("pdf.service.taxes", { rate: (taxRate.value * 100).toFixed(0) })), 1)
                                        ]),
                                        _: 1
                                    }, 8, ["style"]),
                                    _createVNode(_unref(Text), {
                                        style: _normalizeStyle(styles.value.pricingValue)
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_unref(formatPdfCurrency)(taxAmount.value)), 1)
                                        ]),
                                        _: 1
                                    }, 8, ["style"])
                                ]),
                                _: 1
                            }, 8, ["style"]),
                            _createVNode(_unref(View), {
                                style: _normalizeStyle(styles.value.pricingDivider)
                            }, null, 8, ["style"]),
                            _createVNode(_unref(View), {
                                style: _normalizeStyle(styles.value.pricingTotalRow)
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_unref(Text), {
                                        style: _normalizeStyle(styles.value.pricingTotalLabel)
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(t("pdf.service.total")), 1)
                                        ]),
                                        _: 1
                                    }, 8, ["style"]),
                                    _createVNode(_unref(Text), {
                                        style: _normalizeStyle(styles.value.pricingTotalValue)
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_unref(formatPdfCurrency)(total.value)), 1)
                                        ]),
                                        _: 1
                                    }, 8, ["style"])
                                ]),
                                _: 1
                            }, 8, ["style"])
                        ]),
                        _: 1
                    }, 8, ["style"]),
                    _createVNode(_unref(View), {
                        style: _normalizeStyle(styles.value.footer),
                        fixed: ""
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_unref(Text), {
                                style: _normalizeStyle(styles.value.footerText)
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(__props.itineraryCode), 1)
                                ]),
                                _: 1
                            }, 8, ["style"]),
                            _createVNode(_unref(Text), {
                                style: _normalizeStyle(styles.value.pageIndicator)
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(t("pdf.service.page_indicator", { index: __props.index + 1, total: __props.totalServices })), 1)
                                ]),
                                _: 1
                            }, 8, ["style"])
                        ]),
                        _: 1
                    }, 8, ["style"])
                ]),
                _: 1
            }, 8, ["style"]));
        };
    }
});
